import { useState } from "react";
import CreateAccount from './components/CreateAccount';
import LogIn from './components/Login';
import Missing from './components/Missing';
import Dashboard from './scenes/dashboard';
import Layout from './components/Layout';
import Team from "./scenes/team";
import Contacts from "./scenes/contacts";
import Invoices from "./scenes/invoices";
import Form from "./scenes/form"
import Accounts from "./scenes/app_accounts"
import Settings from "./components/Settings";
import ChangeAccountSettings from "./scenes/ChangeAccountSettings";
import ConnectedAccounts from "./scenes/connected_accounts";
import RequireAuth from './components/RequireAuth';
import PersistLogin from './components/PersistLogin';
import { Routes, Route } from 'react-router-dom';
import { ColorModeContext, useMode } from './theme';
import { CssBaseline, ThemeProvider } from '@mui/material';
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import SettingsBar from "./scenes/global/SettingsBar";
import { useLocation } from 'react-router-dom';
import Cards from "./scenes/Cards";
import SettingsBarProvider from './context/SettingsBarContext'
import MoneyAccounts from "./components/MoneyAccounts";
import Transactions from "./scenes/Transactions";
import Buckets from "./scenes/Buckets";
import EditBuckets from "./scenes/EditBuckets";
import BucketTransactions from "./scenes/BucketTransactions";
import { HideThemeProvider } from "./theme";



const ROLES = {
  'visitor': 1,
  'user': 2,
  'admin': 3
}

function App() {
  const [theme, colorMode] = useMode();

  // const toggleSettingsBar = () => {
  //   setShowSettingsBar(!showSettingsBar);
  // };

  const location = useLocation();
  const excludeTopbarAndSidebar = location.pathname === '/sign-in' || location.pathname === '/create-account';


  return (
    excludeTopbarAndSidebar ? (
      <Routes>
        <Route path="create-account" element={<CreateAccount />} />
        <Route path="sign-in" element={<LogIn />} />
        <Route path="missing" element={<Missing />} />

      </Routes>
    ) : (
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <div className="app" style={{ paddingLeft: '75px' }}>
            <SettingsBarProvider>
              <SettingsBar />
              <Sidebar />

              <main className="content" >
                <HideThemeProvider>
                  <Topbar />
                  <Routes>
                    {/* <Route element={<PersistLogin />}> */}

                    {/* public routes */}



                    {/* private routes */}
                    <Route element={<PersistLogin />}>
                      {/* <Route element={<RequireAuth allowedRoles={[ROLES.admin]} />}> */}
                      <Route element={<RequireAuth />}>
                        <Route path="team" element={<Team />} />
                        <Route path="contacts" element={<Contacts />} />
                        <Route path="invoices" element={<Invoices />} />
                        <Route path="form" element={<Form />} />
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="/accounts" element={<Accounts />} />
                        <Route path="/connected-accounts" element={<ConnectedAccounts />} />
                        <Route path="/money-accounts" element={<MoneyAccounts />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/change-account-settings" element={<ChangeAccountSettings />} />
                        <Route path="/transactions" element={<Transactions />} />
                        <Route path="/buckets" element={<Buckets />} />
                        <Route path="/buckets/edit" element={<EditBuckets />} />
                        <Route path="/bucket-transactions" element={<BucketTransactions />} />
                        <Route path="/cards" element={<Cards />} />
                        <Route path="" element={<Dashboard />} />
                      </Route>
                    </Route>


                    {/* catch all */}
                    <Route path="*" element={<Missing />} />

                    {/* </Route> */}
                    {/* </Route> */}
                  </Routes>
                </HideThemeProvider>
              </main>
            </SettingsBarProvider>
          </div>
        </ThemeProvider>
      </ColorModeContext.Provider >
    )

  );
}

export default App;



